import { useApplicantAPI, useSubmit } from "@certn/api";
import {
  ButtonGroup,
  Modal,
  Dialog,
  DialogHeader,
  DialogContent,
  DialogFooter,
  Select,
  SelectItem,
  PrimaryButton,
} from "@certn/cascadia-react";
import { useState } from "react";
import { Trans, useTranslation } from "react-i18next";

import { useApplicationFormContext } from "../../../ApplicationFormContext";

type NonBiometricDemoResponseModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onSave: () => void;
  demoInteracCode: string;
};

export function NonBiometricDemoSkipModal(
  props: NonBiometricDemoResponseModalProps
) {
  const { isOpen, onClose, onSave, demoInteracCode } = props;

  const { caseId } = useApplicationFormContext();

  const { t } = useTranslation();
  const { data: options, isLoading } = useApplicantAPI(
    `/api/internal/applicant/case/${caseId}/non-biometric-idv/demo-skip-options/`
  );
  const [selectedOption, setSelectedOption] = useState<string>("");

  const { submit, isSubmitting } = useSubmit(
    `/api/internal/applicant/case/${caseId}/non-biometric-idv/demo-skip/`,
    {
      showToastOnError: t("Something went wrong, try again"),
      onSuccess: onSave,
    }
  );

  async function handlePress() {
    await submit({ response: selectedOption, interac_code: demoInteracCode });
  }

  if (!isOpen) {
    return null;
  }

  return (
    <Modal isOpen>
      <Dialog>
        <DialogHeader onClose={onClose}>{t("Demo Response")}</DialogHeader>
        <DialogContent>
          <Select
            isLoading={isLoading}
            testID="skip-demo-select-options"
            isRequired
            label={t("Select result")}
            onSelectionChange={(key) =>
              setSelectedOption(key?.toString() ?? "")
            }
            items={options}
            selectedKey={selectedOption}
          >
            {options?.map((option) => (
              <SelectItem
                id={option.value}
                textValue={option.display_value}
                key={option.value}
              >
                {option.display_value}
              </SelectItem>
            ))}
          </Select>
        </DialogContent>
        <DialogFooter>
          <ButtonGroup>
            <PrimaryButton
              testID="skip-modal-next-step-button"
              size="medium"
              onPress={handlePress}
              isDisabled={!selectedOption || isSubmitting}
              isLoading={isSubmitting}
            >
              <Trans>Next step</Trans>
            </PrimaryButton>
          </ButtonGroup>
        </DialogFooter>
      </Dialog>
    </Modal>
  );
}
